const GRID_INSERTABLE_IMAGE_TYPES = new Set([
  'image/jpeg',
  'image/png',
  'image/gif',
  'image/bmp',
  'image/tiff',
  'image/svg+xml',
  'image/avif',
]);

/**
 * Returns true if the given MIME type represents an image that can be inserted
 * into a NotePartGrid. Uses a conservative allowlist of types verified to
 * generate a preview in the notebook.
 */
export function isGridInsertableImageType(fileType: string | undefined): boolean {
  if (!fileType) {
    return false;
  }
  return GRID_INSERTABLE_IMAGE_TYPES.has(fileType);
}

export const GRID_IMAGE_ACCEPT = [...GRID_INSERTABLE_IMAGE_TYPES].join(',');

export const MAX_GRID_IMAGES = 20;
